export default __webpack_public_path__ + "static/media/CNo.81-0.26753323.jpg";